const loaded = { currentIds: [] };

export function initFbPixel(platformId, customId) {
  const ids = [platformId, customId].filter(Boolean);
  if (!ids.length) return;

  if (loaded.currentIds.join() === ids.join()) return;
  loaded.currentIds = ids;

  const existing = document.getElementById('fb-pixel');
  if (existing) existing.remove();

  window.fbq = window.fbq || function () {
    window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = window.fbq;
  window.fbq.push = window.fbq;
  window.fbq.loaded = true;
  window.fbq.version = '2.0';
  window.fbq.queue = window.fbq.queue || [];

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  script.id = 'fb-pixel';
  document.head.appendChild(script);

  ids.forEach((id) => {
    window.fbq('init', id);
  });
}

export function trackPageView() {
  const ids = loaded.currentIds;
  if (!window.fbq || !ids.length) return;
  window.fbq('track', 'PageView');
}
